import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { deleteAdmin, getUsers } from "../../../api/admins";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button } from "reactstrap";

import { useNavigate } from "react-router-dom";

export default function AdminsList() {
  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  const role = currentUser.role || currentUser.roleName || "";
  const canCreate = () =>
    role.name === "super admin" || (role.permissions[0].actions.includes("create") && role.permissions[0].resource === "Monitor");

  const canEdit = () =>
    role.name === "super admin" || (role.permissions[0].actions.includes("update") && role.permissions[0].resource === "Monitor");

  const canDelete = () =>
    role.name === "super admin" || (role.permissions[0].actions.includes("delete") && role.permissions[0].resource === "Monitor");

  const canRead = () =>
    role.name === "super admin" || (role.permissions[0].actions.includes("read") && role.permissions[0].resource === "Monitor");


  useEffect(() => {
    console.log("Current User:", currentUser);
    console.log("Role:", role.name);
    console.log("Permissions:", role.permissions[0].actions);
    console.log("Position:", role.permissions[0].resource);
    console.log("canCreate:", canCreate());
    console.log("canEdit:", canEdit());
    console.log("canDelete:", canDelete());
    console.log("canRead:", canRead());
  }, [currentUser]);

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setMeta,
    totalPages,
  } = usePagination(getUsers, null, true);

  let navigate = useNavigate();
  const [filters, setFilters] = useState({
    roleId: null,
    email: "",
  });
  function handleFilter() {
    setMeta((m) => ({
      ...m,
      page: 1,
      payload: {
        ...filters,
      },
    }));
  }

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this admin?")) {
      try {
        await deleteAdmin(id);
        setPage(1);
      } catch (error) {
        console.error("Delete failed:", error);
        alert("Failed to delete admin.");
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={"Administrators"}
          addUrl={canCreate() ? "/add-admin" : null}
          hasAddBtn={canCreate()}
          isMainPage={true}
        />

        {/* Show admins list only if canRead */}
        {canRead() ? (
          response && response.length > 0 && !loading ? (
            <CustomTable
              emptyMsg={"No Users Found."}
              data={response}
              loading={loading}
              error={error}
              cols={[
                {
                  label: "Name",
                  key: "name",
                  style: { width: "10%" },
                },
                {
                  label: "Email",
                  key: "email",
                  style: { width: "33%" },
                },
                {
                  label: "Role",
                  key: "roleName",
                  style: { width: "15%" },
                  renderer: (row) => row.roleId?.name || "-",
                },
                // {
                //   label: "Permissions",
                //   key: "permissions",
                //   style: { width: "20%" },
                //   renderer: (row) => (
                //     <>
                //       {row.roleId?.permissions?.map((perm, index) => (
                //         <div key={index}>{perm.actions.join(", ")}</div>
                //       ))}
                //     </>
                //   ),
                // },
                {
                  label: "Position",
                  key: "position",
                  style: { width: "17%" },
                  renderer: (row) => (
                    <>
                      {row.roleId?.permissions?.map((perm, index) => (
                        <div key={index}>{perm.resource}</div>
                      ))}
                    </>
                  ),
                },
                {
                  label: "Actions",
                  key: "actions",
                  style: { width: "20%" },
                  renderer: (row) => (
                    <div className="d-flex gap-2">
                      {role === "super admin" ? (
                        <div>No actions allowed</div>
                      ) : (
                        <>
                          {canEdit() && (
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => navigate(`/admins/edit-admin/${row._id}`)}
                            >
                              Edit
                            </Button>
                          )}
                          {canDelete() && (
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleDelete(row._id)}
                            >
                              Delete
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          ) : (
            !loading && <div>No results found.</div>
          )
        ) : (
          <div>You do not have permission to view this list.</div>
        )}

        {response && !loading && canRead() && (
          <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
        )}
      </div>
    </div>
  );
}
